import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`
